export interface CastMember {
  name: string;
  role: string;
  description: string;
  imageUrl: string;
}

export const castMembers: CastMember[] = [
  {
    name: '张凯',
    role: '林',
    description: '从警校毕业生到王牌特工的蜕变，张凯用精湛的演技诠释了主角的成长与挣扎。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20male%20actor%20in%20his%20early%2030s%2C%20sharp%20features%2C%20intense%20determined%20expression%2C%20wearing%20a%20dark%20tactical%20jacket%2C%20moody%20cinematic%20lighting%20with%20warm%20amber%20tones%2C%20editorial%20photography%20style%2C%20clean%20background&width=600&height=600&seq=cast-zhangkai&orientation=portrait',
  },
  {
    name: '陈晓',
    role: '苏婉',
    description: '冷艳与柔情并存的女特工，陈晓的出色演绎让苏婉成为无数观众心中的经典角色。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20female%20actress%20in%20her%20late%2020s%2C%20striking%20features%2C%20cool%20and%20composed%20expression%2C%20wearing%20a%20sleek%20black%20outfit%2C%20cinematic%20lighting%20with%20cool%20tones%2C%20fashion%20editorial%20style%2C%20elegant%20and%20powerful%20presence&width=600&height=600&seq=cast-chenxiao&orientation=portrait',
  },
  {
    name: '刘洋',
    role: '"幽灵"',
    description: '第二季全新反派角色，神秘的背景和复杂的动机让他成为林最危险的对手。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20middle-aged%20Asian%20male%20actor%20with%20an%20enigmatic%20expression%2C%20salt%20and%20pepper%20hair%2C%20wearing%20a%20tailored%20dark%20suit%2C%20dramatic%20side%20lighting%20creating%20shadows%2C%20intense%20and%20mysterious%20atmosphere%2C%20cinematic%20portrait%20photography&width=600&height=600&seq=cast-liuyang&orientation=portrait',
  },
  {
    name: '王德顺',
    role: '陈长官',
    description: '暗影组织的最高负责人，老戏骨王德顺的沉稳气场为整部剧奠定了厚重的基调。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20elderly%20Asian%20male%20actor%20in%20his%2060s%2C%20distinguished%20gray%20hair%2C%20wise%20and%20authoritative%20expression%2C%20wearing%20a%20formal%20dark%20suit%2C%20warm%20studio%20lighting%2C%20classic%20portrait%20style%2C%20dignified%20presence&width=600&height=600&seq=cast-wangdeshun&orientation=portrait',
  },
  {
    name: '赵小曼',
    role: '李娜',
    description: '国际刑警组织精英探员，赵小曼以利落的动作戏和敏锐的表演征服了观众。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20female%20actress%20with%20athletic%20build%2C%20confident%20and%20sharp%20expression%2C%20wearing%20a%20professional%20blazer%2C%20clean%20modern%20lighting%2C%20empowering%20and%20dynamic%20portrait%20style&width=600&height=600&seq=cast-zhaoxiaoman&orientation=portrait',
  },
  {
    name: '黄志伟',
    role: '马克',
    description: '红蝎集团核心成员，黄志伟将反派角色的复杂性演绎得入木三分。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20male%20actor%20in%20his%2040s%2C%20rugged%20features%20with%20a%20subtle%20dangerous%20charisma%2C%20wearing%20a%20dark%20leather%20jacket%2C%20dramatic%20low-key%20lighting%2C%20intense%20and%20brooding%20atmosphere%2C%20cinematic%20villain%20aesthetic&width=600&height=600&seq=cast-huangzhiwei&orientation=portrait',
  },
];

export interface PlotPoint {
  title: string;
  description: string;
  icon: string;
}

export const plotHighlights: PlotPoint[] = [
  {
    title: '暗影崛起',
    description: '从警校毕业生到秘密特工的转折点，林在银行劫案中展露头角，被神秘组织"暗影"招募。',
    icon: 'ri-shield-flash-line',
  },
  {
    title: '卧底红蝎',
    description: '潜入国际军火走私集团"红蝎"，在步步惊心的卧底行动中应对生死考验与身份危机。',
    icon: 'ri-spy-line',
  },
  {
    title: '搭档之谜',
    description: '与女特工苏婉从互不信任到生死相依，她隐藏的过去与"红蝎"有着千丝万缕的联系。',
    icon: 'ri-heart-pulse-line',
  },
  {
    title: '游轮决战',
    description: '公海游轮上的终极对决，阻止军火交易的同时揭开惊天阴谋，苏婉的牺牲令人心碎。',
    icon: 'ri-ship-line',
  },
  {
    title: '新敌降临',
    description: '第二季全新反派"幽灵"登场，更大的国际阴谋浮出水面，特工小队面临前所未有的挑战。',
    icon: 'ri-ghost-line',
  },
];

export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '赤裸特工一共有几季？',
    answer: '目前赤裸特工已播出一季（12集），第二季将于2026年9月15日正式首播，共12集，每集60分钟。制作方已确认第三季正在筹备中。',
  },
  {
    question: '赤裸特工在哪里可以观看？',
    answer: '赤裸特工可在腾讯视频、爱奇艺、优酷和B站四大主流平台观看，均支持4K超高清画质。各平台会员价格从20元到25元每月不等，建议选择年卡获得更优惠的价格。',
  },
  {
    question: '赤裸特工是根据真实事件改编的吗？',
    answer: '赤裸特工是虚构作品，但其创作团队参考了大量真实的国际安全案例和特工行动资料，在保持娱乐性的同时力求呈现特工世界的真实质感。部分训练场景的设计灵感来自真实的特种部队训练体系。',
  },
  {
    question: '赤裸特工的主要演员有哪些？',
    answer: '主演阵容包括张凯（饰演林）、陈晓（饰演苏婉）、刘洋（饰演"幽灵"）、王德顺（饰演陈长官）、赵小曼（饰演李娜）、黄志伟（饰演马克）等实力派演员。',
  },
  {
    question: '第二季和第一季有什么关联？需要先看第一季吗？',
    answer: '第二季的剧情紧密承接第一季结尾，强烈建议先观看第一季以充分理解人物关系和剧情背景。不过制作方也会在第二季首集安排简要的前情回顾，帮助新观众快速入门。',
  },
  {
    question: '赤裸特工会有电影版吗？',
    answer: '根据制作方透露，赤裸特工的电影版正在前期筹备阶段，预计将在电视剧系列完结后推出。电影版将是一个独立的故事，但会与剧集共享同一世界观。',
  },
];

export interface StatItem {
  value: string;
  label: string;
  icon: string;
}

export const stats: StatItem[] = [
  { value: '50亿+', label: '累计播放量', icon: 'ri-play-circle-line' },
  { value: '9.2', label: '豆瓣评分', icon: 'ri-star-line' },
  { value: '12项', label: '行业大奖', icon: 'ri-trophy-line' },
  { value: '150+', label: '覆盖国家地区', icon: 'ri-global-line' },
];